import { configureStore } from "@reduxjs/toolkit";
import { api } from "../../services";
import authReducer from "./reducers/authSlice";
import pointsReducer from "./reducers/points";

export const store = configureStore({
  reducer: {
    [api.reducerPath]: api.reducer,
    auth: authReducer,
    points: pointsReducer
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(api.middleware),
});
